
import * as marietta from '../../../';
import * as THREE from 'three';

export interface pix2D extends THREE.Vector2 {};
export interface mm2D extends THREE.Vector2 {};

export class Unit {

    constructor() {
        ;
    }

    static convertMmtoPix (mmData: mm2D): pix2D {
        const x = marietta.webcad.util.WebCADUtil.convertMMToPix(mmData.x);
        const y = marietta.webcad.util.WebCADUtil.convertMMToPix(mmData.y);
        const pixel = <pix2D>(new THREE.Vector2(x, y));
        return pixel;
    }

    static convertPixtoMm (mmData: pix2D): mm2D {
        const x = marietta.webcad.util.WebCADUtil.convertPixToMM(mmData.x);
        const y = marietta.webcad.util.WebCADUtil.convertPixToMM(mmData.y);
        const mm = <mm2D>(new THREE.Vector2(x, y));
        return mm;
    }

}